import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PersonIcon from '@material-ui/icons/Person';
import { ROUTE_MY_PROFILE } from '../../routes/constants';
import i18n from '../../i18n';

class MyProfileMenuLink extends Component {
  render() {
    return (
      <Link className='activeUserChip' to={ROUTE_MY_PROFILE}>
        <PersonIcon className='userChipIcon' />
        <span className='userChipText'>{i18n.t('myProfile').toUpperCase()}</span>
      </Link>
    );
  }
}

export default MyProfileMenuLink;
